import React, { Component } from "react";


class MainNav extends Component {
  state = {
    navActive: ""
  }
  handleActiveNav = () => {
    const { navActive } = this.state;
    this.setState({ navActive: navActive !== "" ? "" : "nav-active " })
  }
  render() {
    const { settings, language } = this.props;

    const { navActive } = this.state;
    return (
      <div className="container mx-auto" style={{ maxWidth: "100%" }}>
        <nav className="flex items-center justify-between flex-wrap p-2 m-auto border-accent-lightest border-b-4" >
          <div className="cursor-pointer w-2/3 sm:w-auto md:w-auto lg:w-auto xl:w-auto flex items-center text-primary-lightest mr-6">

            <img
              src={settings.header_logo}
              alt="Logo"
              className="block mx-auto h-8 sm:h-16"
            />

          </div>
          <div className="flex lg:hidden">
            <button className="flex items-center px-3 py-2 border rounded text-accent-contrast border-accent-light hover:text-accent-dark hover:bg-accent-lightest" onClick={this.handleActiveNav}>
              <svg
                className="fill-current h-3 w-3"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
              </svg>
            </button>
          </div>
          {settings.webtitle_long !== "" && (
            <div className="w-full mt-4 block flex-grow lg:flex lg:items-center lg:w-auto lg:mt-0">

              <span className="cursor-pointer font-semibold text-xl  tracking-tight" >
                {settings.webtitle_long}
              </span>

            </div>
          )}
          <div className={`${navActive}nav-items w-full block lg:flex lg:items-center lg:w-auto`}>
            <div className="text-sm lg:flex-grow ">
              <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                Winners
                </span>

              {settings && settings.webhowitworkstext && settings.webhowitworkstext !== "0" && (
                <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                  {language.en.howitworks_link_name}
                </span>
              )}
              {settings && settings.weblocationtroubleshootingtext && settings.weblocationtroubleshootingtext !== "0" && (
                <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                  {language.en.locationtroubleshooting_link_name}
                </span>
              )}
              {settings && settings.webaboutustext && settings.webaboutustext !== "0" && (
                <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                  {language.en.aboutus_link_name}
                </span>
              )}
              {settings && settings.webclaimformstext && settings.webclaimformstext !== "0" && (
                <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                  {language.en.claimforms_link_name}
                </span>
              )}
              {settings && settings.webfaqtext && settings.webfaqtext !== "0" && (
                <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                  {language.en.faq_link_name}
                </span>
              )}
              {settings && settings.webrulestext && settings.webrulestext !== "0" && (
                <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                  {language.en.rules_link_name}
                </span>
              )}
              {settings && settings.webproceedstext && settings.webproceedstext !== "0" && (
                <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                  {language.en.proceeds_link_name}
                </span>
              )}
              <span className="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-secondary hover:text-accent mr-4 winnersHeaderLink" >
                {language.en.contactus_link_name}
              </span>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default MainNav;
